<template>
  <FetchJson :url="getIasDocumentUrl()">
    <template #default="{ json: urls }">
      <FetchJson :url="url">
        <template #default="{ json }">
          <InfoBlock>
            <template v-slot:header>Качество ведения документов</template>
            <template v-slot:default>
              <BaseTable :columns="columns">
                <template #rows>
                  <tr
                    v-for="(row, indx) in json.values"
                    :key="indx"
                    class="table__tr"
                  >
                    <td class="table__td">{{ row.documentType }}</td>
                    <td class="table__td">{{ row.documentsTotal }}</td>
                    <td class="table__td">{{ row.missingRequiredFields }}</td>
                    <td class="table__td">
                      {{ row.missingDocumentTerritory }}
                    </td>
                    <td class="table__td">{{ row.missingVectorData }}</td>
                    <td class="table__td">{{ row.missingFiles }}</td>
                    <td class="table__td">
                      <PercentProgressIndicator
                        :value="
                          getPercentRounded(
                            row.validDocumentsCount,
                            row.documentsTotal
                          )
                        "
                        :highQuality="row.validDocumentsCount"
                        :lowQuality="
                          row.documentsTotal - row.validDocumentsCount
                        "
                      />
                    </td>
                    <td>
                      <a
                        v-if="urls.find((doc) => doc.name === row.documentType)"
                        class="navbar__menu-item navbar__button-icon tooltip"
                        target="_blank"
                        :href="
                          urls
                            .find((doc) => doc.name === row.documentType)
                            .url.replace('{schema}', filter.territory.alias)
                            .replace('{GEOMETAURL}', 'https://gisogd-app.e-dag.ru')
                            .replace('{from}', convertDateToString(filter.from))
                            .replace('{to}', convertDateToString(filter.to))
                        "
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.561 3.90238H2.439V16.0975H17.561V3.90238ZM2.439 2.43896C1.63078 2.43896 0.975586 3.09416 0.975586 3.90238V16.0975C0.975586 16.9057 1.63078 17.5609 2.439 17.5609H17.561C18.3692 17.5609 19.0244 16.9057 19.0244 16.0975V3.90238C19.0244 3.09416 18.3692 2.43896 17.561 2.43896H2.439Z"
                            fill="#90A0B7"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.5614 9.26858H2.43945V8.29297H17.5614V9.26858Z"
                            fill="#90A0B7"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M6.82959 16.0974V4.87793H7.8052V16.0974H6.82959Z"
                            fill="#90A0B7"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.1953 16.0974V4.87793H13.1709V16.0974H12.1953Z"
                            fill="#90A0B7"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.5614 5.36576H2.43945V3.90234H17.5614V5.36576Z"
                            fill="#90A0B7"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.5614 13.1704H2.43945V12.1948H17.5614V13.1704Z"
                            fill="#90A0B7"
                          />
                        </svg>
                        <span class="tooltiptext"
                          >Посмотреть все документы. Будет произведен переход в
                          основное приложение.</span
                        >
                      </a>
                    </td>
                  </tr>
                </template>
              </BaseTable>
            </template>
          </InfoBlock>
        </template>
      </FetchJson>
    </template>
  </FetchJson>
</template>

<script>
import { computed, toRefs } from "vue";
import { dateToString } from "@/modules/date";
import PercentProgressIndicator from "@/components/common/PercentProgressIndicator";
import { getPercentRounded } from "@/modules/number";

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  components: { PercentProgressIndicator },
  setup(props) {
    const filter = toRefs(props.filter);
    const url = computed(
      () =>
        `documents/valid-document-quantity-by-type?from=${dateToString(
          filter.from.value
        )}&to=${dateToString(filter.to.value)}&territory=${
          filter.territory.value.alias || ""
        }`
    );

    const columns = [
      "Вид документа",
      "Всего документов",
      "Незаполненные обязательные поля",
      "Без территории действия",
      "Без векторных данных",
      "Без приложенных файлов",
      "% качественных документов",
      "",
    ];

    function getIasDocumentUrl() {
      return `documents/urls`;
    }

    function convertDateToString(date) {
        return dateToString(date);
    }

    return {
      url,
      getIasDocumentUrl,
      columns,
      getPercentRounded,
      convertDateToString,
    };
  },
};
</script>

<style>
/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 216px;
  background-color: white;
  color: #465362;
  text-align: left;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #465362;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 10;
  margin-top: 20px;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
